// Shared with components/dashboard/DataTable.jsx's pager, which had this same
// windowed-page-number logic defined privately — pulled out here so a second,
// non-table list (What's New) can render an identical-looking pager without
// duplicating it, and so a future fix to the windowing only has to happen once.

/** A windowed list of page numbers (with "…" gaps) for a numbered pager. */
export function pageList(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const out = [1];
  const left = Math.max(2, current - 1);
  const right = Math.min(total - 1, current + 1);
  if (left > 2) out.push("…");
  for (let i = left; i <= right; i += 1) out.push(i);
  if (right < total - 1) out.push("…");
  out.push(total);
  return out;
}
